module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_272"
    }
  }), _c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0272-01.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "copyright"
    }
  }, [_c('p', [_vm._v("Copyright © 2016 by Lisa Swerling and Ralph Lazar."), _c('br'), _vm._v("All rights reserved. No part of this book may be reproduced in any form without written permission from the publisher.")]), _vm._v(" "), _c('p', [_vm._v("ISBN 978-1-4521-5201-1 (pb)"), _c('br'), _vm._v("ISBN 978-1-4521-5275-2 (epub 2)"), _c('br'), _vm._v("ISBN 978-1-4521-5450-3 (epub 3)"), _c('br'), _vm._v("ISBN 978-1-4521-5449-7 (mobi)")]), _c('br'), _vm._v(" "), _c('p', [_vm._v("Design by Lisa Swerling and Ralph Lazar")]), _vm._v(" "), _c('p', [_vm._v("10 9 8 7 6 5 4 3 2 1")]), _vm._v(" "), _c('p', [_vm._v("Chronicle Books LLC"), _c('br'), _vm._v("680 Second Street"), _c('br'), _vm._v("San Francisco, CA 94107"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.chroniclebooks.com/",
      "target": "_blank"
    }
  }, [_vm._v("www.chroniclebooks.com")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36177294","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/03copyright.vue
// module id = 63
// module chunks = 0